module.exports = __webpack_public_path__ + "static/media/icon-gotmail-light.61199efd.svg";